export const STATUS_TYPES = {
  SUCCESS: 'success',
  FAILED: 'failure',
};

export const STATUS_CLASSTYPES = {
  SUCCESS: 'active',
  FAILED: 'returned',
};
